function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["navigation", "backLink"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useEffect, useMemo, useRef } from "react";
import styled, { css } from "styled-components";
import useBreakpoint from "../../../../../../hooks/useBreakpoint";
import { useFocusWrapper } from "../../../../../../hooks/useFocusWrapper";
import breakpoint from "../../../../../../utils/breakpoint";
import isNotEmpty from "../../../../../../utils/isNotEmpty";
import DispatchContext from "../../../contexts/DispatchContext";
import StateContext from "../../../contexts/StateContext";
import { ActionType } from "../../../reducers/mainReducer";
import { hugeBreakpointValue } from "../../settings";
import NavigationDropdownOrg from "./NavigationDropdownOrg";
import NavigationListOrg from "./NavigationListOrg";
var Wrapper = styled.div.withConfig({
  componentId: "sc-1fupz0a-0"
})(function (_ref) {
  var $isMobileNavigationOnDesktop = _ref.$isMobileNavigationOnDesktop;
  return $isMobileNavigationOnDesktop ? null : css(["", "{display:flex;justify-content:center;}"], breakpoint(hugeBreakpointValue));
});
var Container = styled.nav.withConfig({
  componentId: "sc-1fupz0a-1"
})(function (_ref2) {
  var $isMobileNavigationOnDesktop = _ref2.$isMobileNavigationOnDesktop;
  return css(["", "{height:100%;}", ""], breakpoint("small", $isMobileNavigationOnDesktop ? undefined : hugeBreakpointValue), $isMobileNavigationOnDesktop ? null : css(["", "{position:relative;}"], breakpoint(hugeBreakpointValue)));
});
function NavigationOrg(_ref3) {
  var navigation = _ref3.navigation,
    backLink = _ref3.backLink,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var dispatch = useContext(DispatchContext);
  var _useContext = useContext(StateContext),
    navigationIndex = _useContext.navigationIndex,
    isMobileNavigationOnDesktop = _useContext.isMobileNavigationOnDesktop;
  var _useFocusWrapper = useFocusWrapper(),
    focusWrapperRef = _useFocusWrapper.focusWrapperRef,
    isWrapperFocused = _useFocusWrapper.isWrapperFocused,
    handleOnFocusWrapper = _useFocusWrapper.handleOnFocusWrapper,
    handleOnBlurWrapper = _useFocusWrapper.handleOnBlurWrapper;
  var isHugeScreenBreakpoint = useBreakpoint(hugeBreakpointValue);
  var isHugeScreen = isHugeScreenBreakpoint && !isMobileNavigationOnDesktop;
  var dropdownRefs = useRef([]);
  var ctaList = useMemo(function () {
    return navigation.map(function (_ref4) {
      var cta = _ref4.cta;
      return cta;
    });
  }, [navigation]);
  var dropdownList = useMemo(function () {
    return navigation.map(function (_ref5, index) {
      var dropdown = _ref5.dropdown;
      return dropdown && _objectSpread({
        index: index
      }, dropdown);
    }).filter(isNotEmpty);
  }, [navigation]);
  var handleMouseLeave = function handleMouseLeave() {
    if (isHugeScreen) {
      dispatch({
        type: ActionType.SET_NAVIGATION_INACTIVE
      });
    }
  };
  useEffect(function () {
    if (!isWrapperFocused && !isHugeScreen && navigationIndex === null) {
      dispatch({
        type: ActionType.SET_NAVIGATION_INACTIVE
      });
    }
  }, [isWrapperFocused]);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    ref: focusWrapperRef,
    onFocus: handleOnFocusWrapper,
    onBlur: handleOnBlurWrapper,
    $isMobileNavigationOnDesktop: isMobileNavigationOnDesktop
  }, restProps), /*#__PURE__*/React.createElement(Container, {
    onMouseLeave: handleMouseLeave,
    role: "navigation",
    $isMobileNavigationOnDesktop: isMobileNavigationOnDesktop
  }, /*#__PURE__*/React.createElement(NavigationListOrg, {
    ctaList: ctaList,
    backLink: backLink,
    dropdownRefs: dropdownRefs
  }), /*#__PURE__*/React.createElement(NavigationDropdownOrg, {
    dropdownList: dropdownList,
    dropdownRefs: dropdownRefs
  })));
}
export default NavigationOrg;